import { useState } from 'react';
import CheckoutCard from '../CheckoutCard';
import CustomerInformation from '@/components/checkout/customer/CustomerInformationDisplay';
import CustomerForm from '@/components/checkout/customer/CustomerForm';
import { useCurrentOrderQuery } from '@/hooks/queries/use-order-query';
import { OrderValidationStatus } from '@/types/api/order/order-validation-status.enum';

export default function CustomerCheckoutCard() {
  const { data: order } = useCurrentOrderQuery();
  // null = not yet overridden by the user; falls back to "editing" whenever the order has no saved customer.
  const [editOverride, setEditOverride] = useState<boolean | null>(null);

  if (!order || order.validationStatus !== OrderValidationStatus.Validated) return null;

  const isEditing = editOverride ?? !order.customer;

  return (
    <CheckoutCard className="relative" isAvailable key={CustomerCheckoutCard.name}>
      <div className="text-gray-800 dark:text-gray-100 font-semibold mb-4">Dina uppgifter</div>
      {isEditing ? (
        <CustomerForm onDone={() => setEditOverride(false)} />
      ) : (
        <CustomerInformation onEdit={() => setEditOverride(true)} />
      )}
    </CheckoutCard>
  );
}
